<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-data-table
          :headers='headers'
          :items='itens'
          class='elevation-1'
          :search="search"
          :items-per-page="itemsPerPage"
          @update:items-per-page=" v => itemsPerPage = v"
        >
          <template v-slot:top>
            <v-toolbar flat color='white'>
              <v-toolbar-title v-text="$t('keywords.listing')" />
              <v-divider class='mx-4' inset vertical></v-divider>
              <v-btn v-has-permission="['desenvolvedor']" color='primary' dark class='mb-2' @click="editItem(null)">{{ $t('button.new') }}</v-btn>
              <ImportExportEmailServer @import="searchAll()" />
            </v-toolbar>

            <SearchField v-model="search" />
          </template>
          <template v-slot:item.lastModified='{ item }'>
            <LastModify :date="item.lastModified" :by="item.lastModifiedBy"/>
          </template>
          <template v-slot:item.actions='{ item }'>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="orange" small class='mr-2' @click='editItem(item)'>mdi-pencil</v-icon>
              </template>
              <span>{{$t('button.edit')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-has-permission="['desenvolvedor']" v-on="on" color="red" small class='mr-2' @click='deleteItem(item)'>mdi-delete</v-icon>
              </template>
              <span>{{ $t('button.delete') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="secondary" small class='mr-2' @click='exportItem(item.serverName)'>mdi-export</v-icon>
              </template>
              <span>{{ $t('core.import_export.export') }}</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            {{ $t('warnings.no_data_found') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/EmailServerService'
import LastModify from '../core/LastModify.vue'
import SearchField from '../core/SearchField.vue'
import ImportExportEmailServer from './ImportExportEmailServer.vue'

export default {
  name: 'emailServerGrid',
  data: () => ({
    itens: [],
    registerName: 'emailserver',
    search: ''
  }),
  mounted () {
    this.searchAll()
  },
  computed: {
    version () { return this.$versionable.versions.emailServer },
    itemsPerPage: {
      get () {
        return this.$cookies.isKey('emailserver_per_page') ? parseInt(this.$cookies.get('emailserver_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('emailserver_per_page', value)
      }
    },
    headers () {
      return [
        {
          text: this.$t('keywords.id'),
          value: 'serverName',
          sortable: false,
          align: 'start'
        },
        {
          text: this.$t('keywords.last_modify'),
          value: 'lastModified',
          sortable: true,
          show: this.version > '1.0.0'
        },
        {
          text: this.$t('emailserver.host'),
          value: 'serverHost',
          sortable: false,
          align: 'start'
        },
        {
          text: this.$t('keywords.credential'),
          value: 'credentialName',
          sortable: false,
          align: 'start'
        },
        {
          text: this.$t('emailserver.from'),
          value: 'from',
          sortable: false,
          align: 'start'
        },
        {
          text: this.$t('keywords.actions'),
          value: 'actions',
          sortable: false
        }
      ].filter(h => h.show ?? true)
    }
  },
  methods: {
    searchAll () {
      this.itens = []
      Servico.findAll()
        .then((result) => (this.itens = result.data))
    },
    editItem (item) {
      this.$emit('editItem', false, item)
    },
    deleteItem (item) {
      if (confirm(this.$t('warnings.confirm.delete'))) {
        Servico.delete(item)
          .then(() => this.searchAll())
          .catch((error) => this.$message.error(`${this.$t('warnings.error.delete')} : ${error}`))
      }
    }
  },
  components: { LastModify, SearchField, ImportExportEmailServer }
}
</script>
